const events = [
  {
    poster_url:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704451330/WhatsApp_Image_2024-01-05_at_16.10.16_nznspe.jpg",

    event_name: "TECHFUSION 2.0",

    description:
      "Coding events inspire innovation, connect tech enthusiasts, and drive skill growth through hackathons, conferences, and meetups .",
  }
];

export default events;